// 获取剩余时间
export function getRemaining(seconds, noStr) {
  if (seconds <= 0) {
    return '00:00:00'
  }
  let t = Math.floor(seconds / 86400)
  let result = seconds % 86400
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  return (noStr ? '' : '剩余') + (t ? t + '天' : '') + (h + ':' + m + ':' + s)
}

export function rndNum(n) {
  let rnd = ''
  for (let i = 0; i < n; i++) {
    rnd += Math.floor(Math.random() * 10)
  }
  return rnd
}



// WEBPACK FOOTER //
// ./src/utils/dateUtil.js